import styles from "./CompleteIcon.module.scss"

const CompleteIcon = () => {
	return (
		<svg
			width="49"
			height="48"
			viewBox="0 0 49 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.5 22.68L23.5465 31L37.5 18"
				fill="none"
				className={styles.checkmark}
				stroke="#D26985"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				className={styles.outline}
				d="M 24.5, 46.5
            a 22.5,22.5 0 1,1 0,-45
            a 22.5,22.5 0 1,1 0,45"
				fill="none"
				stroke="#D26985"
				strokeWidth="3"
			/>
		</svg>
	)
}

export default CompleteIcon
